import { Dropdown } from "@freightsimple/ui-core/Controls/Dropdown";
import { FormItem } from "@freightsimple/ui-core/FormLayout/FormItem";
import { getCarriers } from "@/Data/getCarriers";

interface CarriersDropdownProps {
  carrierIdentifier: string | undefined;
  onCarrierIdentifierChanged: (
    updatedCarrierIdentifier: string | undefined,
  ) => void;
}
function ShipmentFilterCarriersDropdown(props: CarriersDropdownProps) {
  const carrierOptions = getCarriers()
    .filter((c) => c.identifier !== "dummy")
    .map((carrier) => ({
      value: carrier.identifier,
      label: carrier.displayName,
    }));

  const fullOptions = [
    { value: "any-carrier", label: "Any carrier" },
    ...carrierOptions,
  ];

  return (
    <FormItem label="Carrier" fillWidth>
      <Dropdown
        placeholder="Any carrier"
        width="full"
        value={props.carrierIdentifier}
        onChange={(v) => {
          if (v === "any-carrier") {
            props.onCarrierIdentifierChanged(undefined);
          } else {
            props.onCarrierIdentifierChanged(v);
          }
        }}
        options={fullOptions}
      />
    </FormItem>
  );
}
export default ShipmentFilterCarriersDropdown;
